var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"entity"}},[_c('div',{staticClass:"menu-left"},[_c('left-navbar',{attrs:{"left_nav_list":_vm.left_nav_list,"title_top":_vm.title_top,"title_top_path":_vm.title_top_path}})],1),_vm._v(" "),_c('div',{staticClass:"container-view"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6048d930","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/entity/components/Entity.vue
// module id = null
// module chunks = 